type State = { data: Record<string, any>; };

export const selectOngoingCareNoMatch = (state: State) => (state.data.ongoingCareNoMatch);

export const selectReasonNoMatch = (state: State) => (state.data.reasonNoMatch);

export const selectRequestedAppointment = (state: State) => (state.data.requestedAppointment);

export const selectAnyProviderSelected = (state: State) => (state.data.requestedAppointment?.anyProviderSelected);
